import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { CardComponentDataProps } from '../../partials/cards/cards.utils';
import { ThemeContext } from '../../../theming/ThemeProviderWithFonts';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { useTheme } from '../../../theming/useTheme';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { BaseUnit } from '../../../theming/baseUnitDefinition';
import { createImageWidths } from '../../partials/image/image.utils';
import { useThemeOverride } from '../../../theming/useThemeOverride';
import { getLayoutComponentPadding, LayoutComponentBaseProps } from '../pageLayouts/layout.utils';
import { HorizontalCard } from '../../partials/cards/horizontalCard/HorizontalCard';
import { componentConfigThemeKey as horizontalCardConfigThemeKey, HorizontalCardThemeProps } from '../../partials/cards/horizontalCard/horizontalCard.theme';
import { ThreeVC } from './ThreeVC';

export const componentConfigThemeKey = 'oneHCThreeVC';

export interface OneHCThreeVCThemeProps {
    largeHorizontalGap: number;
    mediumHorizontalGap: number;
    smallHorizontalGap: number;
    baseUnit: BaseUnit;
}

interface OneHCThreeVCDataProps extends LayoutComponentBaseProps{
    cards: Array<CardComponentDataProps>;
}

const createStyle = (themeProps: OneHCThreeVCThemeProps) => {
  const { largeHorizontalGap, mediumHorizontalGap, smallHorizontalGap, baseUnit } = themeProps;
  return StyleSheet.create({
    wrapper: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.large]: {
        gridRowGap: `${largeHorizontalGap * baseUnit}px`,
      },
      [MEDIA_BREAKPOINTS.medium]: {
        gridRowGap: `${mediumHorizontalGap * baseUnit}px`,
      },
      [MEDIA_BREAKPOINTS.small]: {
        gridRowGap: `${smallHorizontalGap * baseUnit}px`,
      },
    },
  });
};

const imageWidthsHC = createImageWidths(360, 540, 720);

export const OneHCThreeVC: React.FunctionComponent<OneHCThreeVCDataProps> = props => {
  const { cards, paddingFactors } = props;
  const paddingStyle = getLayoutComponentPadding(paddingFactors);
  const themeProps = useTheme<OneHCThreeVCThemeProps>(componentConfigThemeKey);
  const style = createStyle(themeProps);
  const [firstCard, ...rest] = cards;
  const themeContextHC = useThemeOverride<HorizontalCardThemeProps>({
    titleFontSizeLarge: 'large',
    titleFontSizeMedium: 'large',
    titleFontSizeSmall: 'large',
    metadataFontSizeLarge: 'big',
    metadataFontSizeMedium: 'big',
    metadataFontSizeSmall: 'big',
    shouldReverseImageAlignment: true,
    cardProportionsLarge: { x: 2, y: 1 },
    cardProportionsMedium: { x: 2, y: 1 },
    verticalGapLarge: 1,
    verticalGapMedium: 1,
    verticalGapSmall: 1,
    horizontalGapLarge: 0.75,
    horizontalGapMedium: 0.75,
    horizontalGapSmall: 0.75,
  }, horizontalCardConfigThemeKey);
  return (
    <ErrorBoundary>
      {cards && cards.length > 0
            && (
            <div className={css(paddingStyle, style.wrapper)}>
              <ThemeContext.Provider value={themeContextHC}>
                <HorizontalCard {...firstCard} imageWidths={imageWidthsHC} />
              </ThemeContext.Provider>
              <ThreeVC cards={rest} paddingFactors={{ large: 0, medium: 0, small: 0 }} />
            </div>
            ) }
    </ErrorBoundary>
  );
};
